<template>
  <credit-card-credentials-onboarding v-if="!sourceName" :on-connection="cardConnection"/>
  <div v-else>
    <credentials-details-with-async-fallback :handle-back="deletePageParams">
      <template v-slot:credentials>
        <credentials-details :invalid-credentials="invalidCredentials"
                             :source="source"
                             :name-already-used-error="nameAlreadyUsedError"
                             :set-name-already-in-use-error="setNameAlreadyInUseError"
                             :save-credentials-error="saveCredentialsError"
                             :on-save="saveCredentials"/>
      </template>
    </credentials-details-with-async-fallback>
  </div>
</template>

<script>
import CredentialsDetails from '@/base-components/onboarding/CredentialsDetails';
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import Segment from '@/Segment';
import CredentialsDetailsWithAsyncFallback
  from '@/pages/responsive-pages/authenticated/onboard2/CredentialsDetailsWithAsyncFallback';
import CreditCardCredentialsOnboarding from './CreditCardCredentialsOnboarding.vue';

export default {
  name: 'CreditCardConnectionFlow',
  components: {
    CreditCardCredentialsOnboarding,
    CredentialsDetailsWithAsyncFallback,
    CredentialsDetails,
  },
  async created() {
    Segment.trackUserGot('CreditCardConnectionEntered');
  },
  computed: {
    ...mapState('onboardingState', ['nameAlreadyUsedError', 'saveCredentialsError']),
    ...mapGetters('onboardingState', ['invalidCredentials', 'sourceName']),
    ...mapGetters('sourceFields', ['getSourceBySourceName']),
    source() {
      return this.getSourceBySourceName(this.sourceName);
    },
  },
  methods: {
    ...mapActions('onboardingState', ['saveCredentials', 'deletePageParams', 'deletePageParams']),

    ...mapMutations('onboardingState', ['setPageParams', 'setNameAlreadyInUseError']),
    cardConnection(sourceName) {
      this.setPageParams({ sourceName });
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
